import { CertificateInterface } from '../../domain/interface/certificate_interface';
import { CertificateRepository } from '../../domain/repository/certificate_repository';
import { CertificateApiService } from '../data_source/certificate_api_service';

export class CertificateRepositoryImpl implements CertificateRepository {
  private certificateApiService: CertificateApiService;

  constructor() {
    this.certificateApiService = new CertificateApiService();
  }

  async getCertificateByThemeId(themeId: string): Promise<CertificateInterface> {
    const response = await this.certificateApiService.getCertificateByThemeId(themeId);
    return response.data;
  }
}
